module.exports = __webpack_public_path__ + "img/ic_notifications.c69913cf.svg";